import { render, staticRenderFns } from "./ExamsSwiper.vue?vue&type=template&id=11dcb019&scoped=true&"
import script from "./ExamsSwiper.vue?vue&type=script&lang=js&"
export * from "./ExamsSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ExamsSwiper.vue?vue&type=style&index=0&id=11dcb019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dcb019",
  null
  
)

export default component.exports